import React from 'react';
import FlowerShow2024  from 'views/FlowerShow2024';

const ExtraCurricularActivitiesPage = () => {
  return <FlowerShow2024 />;
};

export default ExtraCurricularActivitiesPage;
